import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

import { ConfirmPopupStyle } from "./style";
import moment from "moment-timezone";

function ConflictPopup(props) {
  const classes = ConfirmPopupStyle();

  return (
    <div className={classes.DeleteWrapper}>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Updating the current rate's end date will conflict with a scheduled rate of <b>{props?.scheduledFuelSurchargeRate}%</b> starting on <b>{moment(props?.scheduledStartDate).format("DD-MM-YYYY")}</b>.<br/>
            Proceed anyway?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.handleClose}
            color="primary"
            className="primary-btn gray-border-btn"
          >
            Discard
          </Button>
          <Button
            onClick={props.handleUpdateFuelSurcharge}
            color="primary"
            className="orange-btn primary-btn center-loading-indicator"
            disabled={props.loading}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default ConflictPopup;
